var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Flex, TextInput, Label } from "../..";
import { inputSectionLss, leftInputLss, labelLss } from '../lib/styles';
import { DashBetweenInputs } from './';
var inputStyleConfig = function (customInputLss) { return ({
    lss: { minHeight: '2rem' },
    inputLss: __assign({ py: 'none' }, customInputLss)
}); };
export var InputSection = function (_a) {
    var id = _a.id, min = _a.min, max = _a.max, step = _a.step, disabled = _a.disabled, leftInputLabel = _a.leftInputLabel, leftInputValue = _a.leftInputValue, onLeftInputChange = _a.onLeftInputChange, rightInputLabel = _a.rightInputLabel, rightInputValue = _a.rightInputValue, onRightInputChange = _a.onRightInputChange, setHasFocus = _a.setHasFocus, inputWrapperLss = _a.inputWrapperLss, inputSectionContainerLss = _a.inputSectionContainerLss, inputLss = _a.inputLss, isDashVisible = _a.isDashVisible;
    var sharedInputConfig = {
        disabled: disabled,
        type: 'number',
        min: min,
        max: max,
        step: step,
        onFocus: function () { return setHasFocus(true); },
        onBlur: function () { return setHasFocus(false); }
    };
    return (React.createElement(Flex, { lss: __assign(__assign({}, inputSectionLss), inputSectionContainerLss) },
        React.createElement(Flex, { lss: __assign(__assign({}, leftInputLss), inputWrapperLss) },
            leftInputLabel && (React.createElement(Label, { htmlFor: "range-min", lss: labelLss }, leftInputLabel)),
            React.createElement(TextInput, __assign({ id: id ? id + "-minimum-input" : undefined, name: "range-min", value: leftInputValue, onChange: onLeftInputChange, "aria-label": "Left Slider Handle value" }, sharedInputConfig, inputStyleConfig(inputLss)))),
        isDashVisible && React.createElement(DashBetweenInputs, null),
        React.createElement(Flex, { lss: __assign({ flexDirection: 'column' }, inputWrapperLss) },
            rightInputLabel && (React.createElement(Label, { htmlFor: "range-max", lss: labelLss }, rightInputLabel)),
            React.createElement(TextInput, __assign({ id: id ? id + "-maximum-input" : undefined, name: "range-max", value: rightInputValue, onChange: onRightInputChange, "aria-label": "Right Slider Handle value" }, sharedInputConfig, inputStyleConfig(inputLss))))));
};
//# sourceMappingURL=InputSection.js.map